import api from './api'
import { toast } from 'react-toastify'

export function findLogsByAtivo(farmaciaId, ativoId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`/farmacias/${farmaciaId}/ativos/${ativoId}/logs`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao buscar logs do ativo");
      return reject(e);
    }
  })
}

export function clearLogs(farmaciaId, ativoId, usuarioId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`/farmacias/${farmaciaId}/ativos/${ativoId}/logs`, {
        headers: { authorization: `Bearer ${token}` },
        params: { usuarioId }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao limpar logs do ativo");
      return reject(e);
    }
  })
}
